import { render, staticRenderFns } from "./AppToken.vue?vue&type=template&id=56efa052&scoped=true"
import script from "./AppToken.vue?vue&type=script&lang=js"
export * from "./AppToken.vue?vue&type=script&lang=js"
import style0 from "./AppToken.vue?vue&type=style&index=0&id=56efa052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56efa052",
  null
  
)

export default component.exports